import React, { useEffect, useState } from "react";
import { walletAPI } from "../../utils/api/WalletAPI";
import { useParams } from "react-router-dom";

export const UnitCountSeven = () => {
  const [summary, setSummary] = useState({});
  const [loading, setLoading] = useState(true);
  const { id } = useParams();

  useEffect(() => {
    if (!id) return;

    setLoading(true);
    Promise.all([
      walletAPI({ organizationId: id }),
    ])
      .then(([walletData]) => setSummary(walletData))
      .finally(() => setLoading(false));
  }, [id]);

  const shimmerCard = () => (
    <div className='col-xxl-3 col-xl-4 col-sm-6'>
      <div className='px-20 py-16 shadow-none radius-8 h-100 shimmer'>
        <div className='mb-3 shimmer-text'></div>
        <div className='shimmer-text'></div>
      </div>
    </div>
  );

  const cardData = [
    {
      title: "Total Credits",
      value: summary?.totalCredits,
      icon: "ri-time-fill",
      gradient: "gradient-deep-1",
      lineBg: "line-bg-primary",
      bgColor: "bg-primary-100",
      iconColor: "text-primary-600",
    },
    {
      title: "Credit Used",
      value: summary?.creditsUsed,
      icon: "ri-arrow-up-circle-fill",
      gradient: "gradient-deep-4",
      lineBg: "line-bg-warning",
      bgColor: "bg-warning-focus",
      iconColor: "text-warning-600",
    },
    {
      title: "Remaining Credits",
      value: summary?.creditsRemaining,
      icon: "ri-wallet-3-fill",
      gradient: "gradient-deep-3",
      lineBg: "line-bg-success",
      bgColor: "bg-success-200",
      iconColor: "text-success-600",
    },
    {
      title: "Grace Credit",
      value: summary?.graceCredits,
      icon: "ri-phone-fill",
      gradient: "gradient-deep-2",
      lineBg: "line-bg-lilac",
      bgColor: "bg-lilac-200",
      iconColor: "text-lilac-600",
    },
  ];

  return (
    <div className='col-12'>
      <div className='card radius-12'>
        <div className='card-body p-18'>
          <div className='row gy-4'>
            {loading
              ? Array(4).fill(0).map((_, i) => <React.Fragment key={i}>{shimmerCard()}</React.Fragment>)
              : cardData.map((item, i) => (
                <div className='col-xxl-3 col-xl-4 col-sm-6' key={i}>
                  <div className={`px-20 py-16 shadow-none radius-8 h-100 ${item.gradient} left-line ${item.lineBg} position-relative overflow-hidden`}>
                    <div className='d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8'>
                      <div>
                        <span className='mb-2 fw-medium text-secondary-light text-md'>
                          {item.title}
                        </span>
                        <h6 className='fw-semibold mb-1'>
                          {(item.value / 60).toFixed(2)}
                        </h6>
                      </div>
                      <span className={`w-44-px h-44-px radius-8 d-inline-flex justify-content-center align-items-center text-2xl mb-12 ${item.bgColor} ${item.iconColor}`}>
                        <i className={item.icon} />
                      </span>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnitCountSeven;
